import React from 'react';
import './style.css';
import { useNavigate } from 'react-router-dom';
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';

import heroSection_four from '../../../Assets/resource/Homechargerbanner.png';



export default function Banners() {
    const navigate = useNavigate();
    return (
        <section className="banner flex bg-light-gradient pb-0 md:pb-28 lg:pb-40 pt-20 md:pt-28 lg:pt-40 my-10 xl:my-0">
            <div className="z-10 containers-min mx-auto sm:flex  md:flex-row flex-col sm:items-center ">
                <div className="md:w-6/12 h-fit flex justify-center items-start flex-col min-w-[300px] ">
                    <h1 className="leading-tight !h3 font-gilroylight font-light">
                        The Heart of your EV Home: Built for families, trusted by EV drivers
                        {/* <span className="font-gilroy font-bold"> EV Charging! </span>
                        is the Must-Have
                        <span className="font-gilroy font-bold pl-3">
                            Amenity!
                        </span> */}
                    </h1>
                    <h5 className="lg:mt-6 mt-4 font-poppins">
                        Home charger that delivers a smooth, secure, and efficient charging experience
                    </h5>
                    <h5 className="sm:mt-4 lg:mt-6 mt-5 lg:leading-9 leading-normal font-medium font-poppins">
                        Its sleek design and advanced safety features make it the perfect fit for every household. With the EV Life App, enjoy full control, smart schedulling, and a seamless charging experince
                    </h5>
                    <div
                        className='mt-5'
                        onClick={() => {
                            navigate('/get-in-touch')
                        }}
                    >
                        {/* <button
                        className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6'
                      >
                        <span className="flex justify-center items-center">
                          <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                          <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                        </span>
                        Contact Us
                      </button>                      */}
                    </div>
                </div>

                <div className="md:w-5/12 w-full p-4 md:mt-0 mt-10 mx-auto relative lg:min-h-[400px] min-h-[300px]">
                    <div className="absolute top-20 left-auto -bottom-20 -right-20 bg-gradient w-32 md:w-56 lg:w-80 hidden md:block"></div>
                    <img
                        loading="lazy"
                        className="h-full w-full rounded-lg z-10 relative"
                        src={heroSection_four}
                        alt="Switch to EV"
                    />
                </div>
            </div>
        </section>
    );
}
